module.exports = __webpack_public_path__ + "img/heart.f05253bc.svg";